import { OrganizationRoleType } from "@/types/graphql/partner.generated";

/**
 * Порядок ролей в чекбоксах и чипах — как в таблице спеки
 * (docs/superpowers/specs/2026-09-06-organization-roles-design.md, «Роли»).
 * Подписи и описания — ключи сида `team.roles.<role>.label|description`
 * (backend/src/migrations/data/partnerSeed/team.ts), берутся через t()
 * в UI, здесь только порядок и значения enum.
 */
export const ORGANIZATION_ROLE_ORDER: OrganizationRoleType[] = [
  OrganizationRoleType.AdminType,
  OrganizationRoleType.AnalyticsType,
  OrganizationRoleType.VideosType,
  OrganizationRoleType.StreamsType,
  OrganizationRoleType.ProductsType,
  OrganizationRoleType.UsersType,
  OrganizationRoleType.MarketingType,
  OrganizationRoleType.SettingsType,
];
